/**
 * Where a reporter's chosen chat size is kept — in `sessionStorage` only (see
 * `REPORT_CHAT_SETTINGS`). Its own module so logout can clear it without
 * importing the chat's settings and styles.
 */
export const REPORT_CHAT_SIZE_STORAGE_KEY = 'speeki.chat.size.webportal';
